Ext.define('SA.view.EditViewUnselectableListItem', {
    alias: 'widget.edit-view-unselectable-list-item',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-panel-disabled-item',

    items: [
        {
            xtype: 'component',
            itemId: 'labelCmp',
            cls: 'sa-edit-panel-disabled-item-label'
        }
    ],

    initComponent() {
        this.callParent();

        this.labelCmp = this.down('#labelCmp');
    },

    setLabelHtml(labelHtml) {
        this.labelCmp.update(labelHtml);
    }
});